/**
 * Route for `click-injection-detection-mobile`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ClickInjectionDetectionMobilePage } from "../features/click-injection-detection-mobile/ClickInjectionDetectionMobilePage";

export const clickInjectionDetectionMobileRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/click-injection-detection-mobile",
	component: ClickInjectionDetectionMobilePage,
});

export default clickInjectionDetectionMobileRoute;
